import React from 'react';
import cn from '../../../../lib/bem';
import { useNavigate } from 'react-router-dom';
import ico_error from './../../../../assets/icons/ico_error.svg';
import ButtonComponent from '../../../../components/button/button_component';

import './errorPage.scss';

const ErrorPage = () => {
    
    const classes  = cn("errorPage");
    const history = useNavigate();

    return (
        <div className={classes()}>
            <div className={classes('errorPageMensajeDiv')}>
                <img src={ico_error} alt='cobrar' />
                <p className={classes('titleErrorPageMensaje')}><b>Hemos tenido un inconveniente</b></p>
                <p className={classes('descrErrorPageMensaje')}>En este momento no hemos podido procesar tu solicitud. Por favor, intenta m&aacute;s tarde. </p>
                <div className={classes('btnErrorContinuarMensaje')}>
                    <ButtonComponent label={'btnContinuar'} nombre={'Volver al Home'} tipo={'button-red'} action={() => history('/')} disabled={false}/>
                </div>
            </div>
        </div>
    );
};

export default ErrorPage;
